const cartDrawerButton=document.querySelector(".menu-tools__item--cart a"),cartNotice=document.querySelector(".drawer-cart__notice"),updateDrawerQuantity=(cartDrawerButton&&cartDrawerButton.addEventListener("click",t=>{t.preventDefault(),document.querySelector("body").classList.contains("drawer-cart-open")?window.closeAllDrawers(()=>{}):window.closeAllDrawers(()=>{window.updateCartDrawer(),window.openCartDrawer()})}),t=>{var e=t.value,t=t.dataset.id,a={updates:{}};a.updates[t]=e,fetch(window.Shopify.routes.root+"cart/update.js",{method:"POST",headers:{"Content-type":"application/json"},body:JSON.stringify(a)}).then(t=>t.json()).then(()=>{window.updateCartDrawer()}).catch(t=>{console.log(t)})}),initCartDrawerQuantity=()=>{var t=document.getElementById("drawer-cart-content"),e=t.querySelectorAll(".cart-quantity");if(e)for(let t=0;t<e.length;t++){const r=e[t].querySelector("input");let a=r.value;const n=e[t].querySelectorAll(".increment");for(let e=0;e<n.length;e++)n[e].addEventListener("click",t=>{if(t.preventDefault(),n[e].classList.contains("down")){if(a<=0)return;a--}n[e].classList.contains("up")&&a++,r.setAttribute("value",a),updateDrawerQuantity(r)})}t=t.querySelectorAll("input");if(t)for(const a of t)a.addEventListener("keyup",()=>{clearTimeout(window.inputDelay),window.inputDelay=setTimeout(()=>{updateDrawerQuantity(a)},500)})},initCartDrawerRemove=()=>{var t=document.getElementById("drawer-cart-content").querySelectorAll(".remove");if(t)for(const a of t)a.addEventListener("click",t=>{t.preventDefault();var t=a.dataset.product,e={updates:{}};e.updates[t]=0,fetch(window.Shopify.routes.root+"cart/update.js",{method:"POST",headers:{"Content-type":"application/json"},body:JSON.stringify(e)}).then(t=>t.json()).finally(()=>{window.updateCartDrawer()}).catch(t=>{console.log(t)})})},fetchVariantAvailability=(window.updateCartDrawer=()=>{let r=!0;const t=document.getElementById("drawer-cart-content"),n=t.querySelector(".cart-items"),i=(n.innerHTML="",document.getElementById("drawer-cart-totals")),e=document.getElementById("drawer-cart-footer");t.classList.add("content-loading"),fetch(window.Shopify.routes.root+"cart").then(t=>t.text()).then(t=>{let e="",a="";0<t.indexOf("\x3c!--[cart-empty]--\x3e")?(e=t.split("\x3c!--[cart-empty]--\x3e").pop().split("\x3c!--[/cart-empty]--\x3e")[0],a=""):(e=t.split("\x3c!--[cart-items]--\x3e").pop().split("\x3c!--[/cart-items]--\x3e")[0],a=t.split("\x3c!--[cart-total]--\x3e").pop().split("\x3c!--[/cart-total]--\x3e")[0],r=!1),n.innerHTML=e,i.innerHTML=a}).finally(()=>{t.classList.remove("content-loading"),!0===r?e.classList.add("hide-content"):e.classList.remove("hide-content"),console.log("robot rock",t,t.querySelectorAll(".cart-quantity")),getAllVariantAvailabilities(Array.from(t.querySelectorAll(".cart-quantity")).map(t=>t.dataset.id)),initCartDrawerQuantity(),initCartDrawerRemove(),window.getCartTotal(),window.countCartItems(),window.initImageLoad()}).catch(t=>{console.error(t)})},async t=>{return(await(await fetch(`/variants/${t}/?section_id=pickup-availability-api`)).text()).includes("AVAILABLE")}),getAllVariantAvailabilities=async t=>{(await Promise.all(t.map(fetchVariantAvailability))).filter(t=>!t).length?cartNotice.classList.remove("hidden"):cartNotice.classList.add("hidden")};
/* ---------- Microsoft UET instrumentation: add_to_cart, begin_checkout, remove_from_cart ---------- */
(function () {
  // Safe queue helper
  function uetPush(eventName, data) {
    try {
      window.uetq = window.uetq || [];
      // Microsoft UET expects: ['event', 'name', {props}]
      window.uetq.push('event', eventName, data || {});
      // console.debug('[UET]', eventName, data);
    } catch (e) {
      // swallow
    }
  }

  // Currency helper
  function activeCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  }

  // 1) BEGIN CHECKOUT from the drawer (and any checkout link inside it)
  document.addEventListener('click', function (e) {
    const t = e.target;
    if (!t) return;

    // Matches common checkout triggers in the drawer and cart page
    const isCheckout =
      t.closest('a[href*="/checkout"]') ||
      t.closest('button[name="checkout"]') ||
      t.closest('form[action="/cart"] [type="submit"]') ||
      (t.matches && (
        t.matches('a[href*="/checkout"]') ||
        t.matches('button[name="checkout"]') ||
        t.matches('form[action="/cart"] [type="submit"]')
      ));

    if (isCheckout) {
      uetPush('begin_checkout', { currency: activeCurrency() });
    }
  }, true);

  // 2) REMOVE FROM CART: hook your existing remove UI
  try {
    const drawer = document.getElementById('drawer-cart-content');
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        const btn = e.target && e.target.closest('.remove');
        if (!btn) return;
        // We don’t have the line item payload here (your code removes by id via /cart/update),
        // but we can still emit a minimal event.
        uetPush('remove_from_cart', {
          variant_id: btn.dataset && btn.dataset.product ? Number(btn.dataset.product) : undefined,
          currency: activeCurrency()
        });
      }, true);
    }
  } catch (_) {}

  // 3) ADD TO CART anywhere in the theme by intercepting fetch('/cart/add.js')
  // This catches product page, quick-add, upsell widgets, etc.
  (function patchFetchForAddToCart() {
    if (window.__uetFetchPatched) return; // idempotent
    window.__uetFetchPatched = true;

    const _fetch = window.fetch;
    window.fetch = function (input, init) {
      const url = (typeof input === 'string') ? input : (input && input.url) || '';
      const method = (init && (init.method || init.headers && init.headers.get && init.headers.get('X-HTTP-Method-Override'))) || 'GET';

      const isAddToCart = url.indexOf('/cart/add.js') > -1 && String(method).toUpperCase() !== 'GET';

      // Call through
      const p = _fetch.apply(this, arguments);

      if (!isAddToCart) return p;

      // Clone the response to read JSON for UET while preserving the original chain
      return p.then(function (resp) {
        try {
          // If we can’t read JSON, just forward
          const clone = resp.clone();
          clone.json().then(function (item) {
            // item shape from Shopify: { id, variant_id, product_id, quantity, final_price, price, ... }
            // Use final_price when available (price * quantity); divide by 100 to convert to major units.
            const value = (item && (item.final_price ?? (item.price * (item.quantity || 1)))) / 100;
            uetPush('add_to_cart', {
              value: isFinite(value) ? value : undefined,
              currency: activeCurrency(),
              product_id: item && item.product_id,
              variant_id: item && (item.variant_id || item.id),
              quantity: item && item.quantity
            });
          }).catch(function () {
            // ignore JSON parse errors
          });
        } catch (_) {
          // ignore
        }
        return resp;
      });
    };
  })();
})();